import script from "./UnitDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitDetails.vue?vue&type=script&setup=true&lang=js"

import "./UnitDetails.vue?vue&type=style&index=0&id=1e339f04&lang=css"

const __exports__ = script;

export default __exports__